import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { Values } from './TemplateAndCaption'

interface Props {
  onChange: (values: Values) => any
}

export const ValuesObserver = ({ onChange }: Props) => {
  const { values } = useFormikContext<Values>()

  useEffect(() => {
    onChange(values)
  }, [values]) // eslint-disable-line
  return null
}
